import '~/scripts/integrations/jquery-extended';

export default class {
  constructor() {
    var container = "#announcements";
    this.$container = $(container);
    var announcements = new R.Announcements(container);
  }
}
